// src/components/CookieNotice.jsx
// Session/auth cookie consent banner — shows once per browser, stores ack in localStorage.
import { useState } from "react";

const STORAGE_KEY = "cookie_notice_accepted";

export default function CookieNotice({ onOpenPrivacy }) {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 99999,
      background: "#0d1117",
      borderTop: "1px solid #1c2333",
      padding: "14px 24px",
      display: "flex",
      alignItems: "center",
      gap: 16,
      flexWrap: "wrap",
      fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
    }}>
      <p style={{
        margin: 0,
        flex: 1,
        minWidth: 240,
        fontSize: 11,
        color: "#8b949e",
        letterSpacing: "0.03em",
        lineHeight: 1.6,
      }}>
        This site uses session cookies for authentication. By continuing, you agree to our{" "}
        <button
          onClick={onOpenPrivacy}
          style={{
            background: "none",
            border: "none",
            padding: 0,
            color: "#3ddc84",
            fontSize: 11,
            fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
            cursor: "pointer",
            textDecoration: "underline",
            letterSpacing: "0.03em",
          }}
        >
          Privacy Policy
        </button>
        .
      </p>
      <button
        onClick={handleAccept}
        style={{
          background: "#3ddc84",
          color: "#0a0a0a",
          border: "none",
          padding: "8px 20px",
          fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: "0.12em",
          cursor: "pointer",
          flexShrink: 0,
        }}
      >
        GOT IT
      </button>
    </div>
  );
}
